import React from 'react';
import { Link } from 'react-router-dom';
import API from '../API';

const ORDER_STATUS = {};
ORDER_STATUS[-1] = {t: "İptal Edildi", color: "#c0c3cf"};
ORDER_STATUS[0] = {t: "Sürücü Aranıyor", color: "rgb(80,72,229)"};
ORDER_STATUS[1] = {t: "Planlanmış", color:"rgb(80,72,229)"};
ORDER_STATUS[2] = {t: "Sürücü Yolda",color:"orange"}
ORDER_STATUS[10] = {t: "Tamamlanmış", color:"green"};

const VEHICLE_IMAGES = [require('../assets/vehicles/Motor.png'),null,require('../assets/vehicles/Doblo.png'),null, require('../assets/vehicles/Panelvan.png'), require('../assets/vehicles/Kamyonet.png')]

export default class BookingDetailsPanel extends React.Component {
    constructor(props) {
        super(props);

        this.state = {menuOpened: false, prompt: false, promptLoading: false};
    }


    componentDidMount() {
        this.mouseClickL = (e) => this.mouseClickListener(e);

        document.addEventListener("mousedown", this.mouseClickL);
        
    }
    componentWillUnmount() {
        document.removeEventListener("mousedown", this.mouseClickL);
    }

    mouseClickListener(event) {
        
        if(!this.menuRef || !this.menuRef.contains(event.target)) {
            var v = this.state.menuOpened;
            setTimeout(() => {
                if(this.state.menuOpened == v) {
                    this.setState({menuOpened: false});
                }
            }, 100);
            //s.menuOpened = false;
        }
       

        this.forceUpdate();
        
    }


    render() {


        return <div className='tdOrder'>
                    <img style={{width:"5vw",objectFit:"contain"}} src={VEHICLE_IMAGES[this.props.order.vehicle]} />

                    <div className='labelSeparator'>
                    <div>
                        <p className='bookingLabel'>Sipariş Numarası</p>
                        <td className='tdID'>#{this.props.order._id.substring(18).toUpperCase()}</td>
                    </div>

                    <div>
                        <p className='bookingLabel'>Oluşturma Tarihi</p>
                        <p>{new Date(parseInt(this.props.order._id.substring(0,8),16)*1000).toLocaleString("islamic")}</p>
                    </div>
                    </div>

                    <div className='waypointRootDiv'>
                        <p className='bookingLabel'>Nereden</p>
                        {API.getDescription(this.props.order.from) != "" && <p>{API.getDescription(this.props.order.from)}</p>}
                        <p>{this.props.order.from.Label}</p>
                    </div>

                    <div className='waypointRootDiv' >
                        <p className='bookingLabel'>Nereye</p>
                        {API.getDescription(this.props.order.to) != "" && <p>{API.getDescription(this.props.order.to)}</p>}
                        <p>{this.props.order.to.Label}</p>
                    </div>


                    <div className='labelSeparator'>
                    <div>
                        <p className='bookingLabel'>Fiyat</p>
                        <p>{this.props.order.pricing.price.toFixed(2)}₺</p>
                    </div>

                    <div>
                        <p className='bookingLabel'>Durumu</p>
                       
                        <div className='bookingStatusDiv' style={{backgroundColor:ORDER_STATUS[this.props.order.status].color,padding:5,paddingLeft:10,paddingRight:10,width:"fit-content", borderRadius:10, color:"white"}}>{ORDER_STATUS[this.props.order.status].t}</div>
                    </div>
                    </div>
                    
                    
                    
                    
                    <div style={{visibility:this.props.order.driverDetails == undefined || this.props.order.status == -1 || this.props.order.status == 10?"hidden":"visible"}} className='bookingPanelDriverRoot'>
                        {this.props.order.driverDetails != undefined && this.props.order.status > 0 && this.props.order.status < 10 && <>
                        <p className='bookingLabel'>Sürücü</p>
                        <img className='bookingPanelDriver' src={'https://tasimacim-driver-pictures.s3.eu-central-1.amazonaws.com/'+this.props.order.driverDetails._id+'.jpeg'} />
                        <p style={{marginTop:5}}>{this.props.order.driverDetails.name}</p>
                        
                        <div className='contactButtons'>
                        <button><svg fill='#3c9cd7' width="25.024"height="25.024"viewBox="0 0 891.024 891.024"><path d="M2.8 180.875c46.6 134 144.7 286.2 282.9 424.399 138.2 138.2 290.4 236.301 424.4 282.9 18.2 6.3 38.3 1.8 52-11.8l92.7-92.7 21.6-21.6c19.5-19.5 19.5-51.2 0-70.7l-143.5-143.4c-19.5-19.5-51.2-19.5-70.7 0l-38.899 38.9c-20.2 20.2-52.4 22.2-75 4.6-44.7-34.8-89-73.899-131.9-116.8-42.9-42.9-82-87.2-116.8-131.9-17.601-22.6-15.601-54.7 4.6-75l38.9-38.9c19.5-19.5 19.5-51.2 0-70.7l-143.5-143.5c-19.5-19.5-51.2-19.5-70.7 0l-21.6 21.6-92.7 92.7C1 142.575-3.5 162.675 2.8 180.875z"></path></svg></button>
                        <button><svg width={25} height={25} viewBox="0 0 58 58"><path fill="#3c9cd7" d="M58 16.207c0-8.822-7.178-16-16-16H17c-8.822 0-17 7.178-17 16v16c0 8.485 7.644 15.429 16 15.949v-3.949a1 1 0 112 0v13.586l1.359-1.359c5.306-5.305 12.359-8.227 19.86-8.227H42c8.822 0 16-7.178 16-16v-16z"></path></svg></button>
                        </div>
                        </>}
                    </div>
                    


                    <div className='labelSeparator' style={{alignItems:"flex-end"}}>

                        <div style={{position:"relative"}}>
                            <div className='menu-trigger' onClick={()=>{ this.state.menuOpened = !this.state.menuOpened; this.forceUpdate(); }}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" x="0" y="0" enableBackground="new 0 0 342.382 342.382" version="1.1" viewBox="0 0 342.382 342.382" xmlSpace="preserve" fill="#c0c3cf">
                                    <path d="M45.225 125.972C20.284 125.972 0 146.256 0 171.191c0 24.94 20.284 45.219 45.225 45.219 24.926 0 45.219-20.278 45.219-45.219 0-24.935-20.293-45.219-45.219-45.219zM173.409 125.972c-24.938 0-45.225 20.284-45.225 45.219 0 24.94 20.287 45.219 45.225 45.219 24.936 0 45.226-20.278 45.226-45.219 0-24.935-20.29-45.219-45.226-45.219zM297.165 125.972c-24.932 0-45.222 20.284-45.222 45.219 0 24.94 20.29 45.219 45.222 45.219 24.926 0 45.217-20.278 45.217-45.219 0-24.935-20.291-45.219-45.217-45.219z"></path>
                                </svg>
                            </div>

                            <div ref={(a) => this.menuRef = a} className={`dropdown-menu ${this.state.menuOpened? 'active' : 'inactive'}`} >
                               
                            {((this.props.order.status <= 1 && this.props.order.status != -1) || (this.props.order.status == 2 && this.props.order.currentWaypoint <= 0)) && <a style={{color:"crimson"}} onClick={() => {
 this.setState({prompt: true});
                            }} className = 'dropdownItem'>
                 Siparişi iptal et 
              </a>}
              <a target={"_blank"} href={'../siparis/'+this.props.order._id} className = 'dropdownItem'>
                <p style={{color:"black"}}> Sipariş takibi </p> <img src={require('../assets/out.png')} style={{marginLeft:10}} width={20} />
              </a>
                                    
                                
                            </div>
                        </div>
                        {this.props.details && <Link to={'../siparisim/' + this.props.order._id}><p className='bookButton' style={{paddingTop:5, paddingBottom:5,flex:0,height:"fit-content"}}>Detayları gör</p></Link>}
                    </div>
                        

                    <div onClick={(e) => {
                        this.setState({prompt: false});
                    }} className={'bookingModalPopupRoot'+(this.state.prompt?" open":"")}>
                    <div onClick={(e) => {
                        e.stopPropagation();
                    }} className='loginModalPhone bookingModalPopup' style={{display:"flex",flexDirection:"column"}}>
            
            {/* <div style={{overflowY:"scroll", width:"50%", height:"50%"}} dangerouslySetInnerHTML={{__html: (() => {

              if(userHTML) return userHTML;

              fetch("/mobileuseragreement.html").then((e) => e.text()).then((e) => {
                userHTML = e;
                this.forceUpdate();
              })
              return "";

            })()}}></div> */}
            
            {this.state.promptLoading == false && <><p className='loginTitle'>Siparişinizi iptal etmek istediğinize emin misiniz?</p>
            {!(this.props.order.status == 2 && this.props.order.driverAssignDate && Date.now()-this.props.order.driverAssignDate >= 300000) && <p className='loginAlt'>Sürücünüz yola çıkmadığından dolayı herhangi bir ücret ödemezsiniz</p>}

            {this.props.order.status == 2 && this.props.order.driverAssignDate && Date.now()-this.props.order.driverAssignDate >= 300000 && <p style={{textAlign:"center", width:"80%", marginTop:20, color:"red"}}>
                            {((this.props.order.nearLocation)?"Sürücünüz ilk teslimat noktasına vardığı için şuan iptal ederseniz *price*₺ iptal bedeli ödemek zorunda kalacaksınız":"Sürücünüz yola çıktığı için şuan iptal ederseniz *price*₺ iptal bedeli ödemek zorunda kalacaksınız").replace("*price*",(this.props.order.pricing.price*(this.props.order.scheduled?2:1)*(this.props.order.nearLocation?.1:.05)).toFixed(2))}
                        </p>}
            
            <div style={{display:"flex", flex:1,gap:20}}>
                <button onClick={(a) => this.setState({prompt: false})} className='bookButton'>Geri Dön</button>
                <button onClick={() => {
                    this.setState({promptLoading: true});

                    API.fetchClient("cancelorder", {_id: this.props.order._id, penalty: (this.props.order.status == 2 && this.props.order.driverAssignDate && Date.now()-this.order.driverAssignDate >= 300000)?(this.props.order.pricing.price*(this.props.order.scheduled?2:1)*(this.props.order.nearLocation?.1:.05)).toFixed(2):(0).toFixed(2)}).then((e) => {
                        if(!e.error) {
                            this.props.order.status = -1;
                            this.setState({prompt: false, promptLoading: false});
                        }
                    })
                }} className='bookButton' style={{backgroundColor:"crimson",border:"none"}}>İptal Et</button>
            </div></>}

            {this.state.promptLoading && <div style={{justifyContent:"center", display:"flex", flex:1}}><div className="loading-spinner-big">
      
      </div></div>}
            
            
        </div>
                    </div>
                </div>
    }
}